import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';

const styles = theme => ({
  listKey: {
    color: theme.palette.lightGrey,
    width: '120px',
    fontSize: '14px'
  }
});

class BorrowerDetails extends React.Component {
  businessAddress = () => {
    const street = _.get(this.props.application, 'form.businessAddress.streetAddress');
    const city = _.get(this.props.application, 'form.businessAddress.city');
    const postcode = _.get(this.props.application, 'form.businessAddress.postcode');
    const state = _.get(this.props.application, 'form.businessAddress.state');
    return [street, city, postcode, state].join(' ');
  }

  render = () => {
    const { application } = this.props;
    return (
      <div>
        <List>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Director" />
            <ListItemText primary={application.form.name} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="ABN/ACN" />
            <ListItemText primary={application.form.abn} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Company" />
            <ListItemText primary={application.form.businessName} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Business Type" />
            <ListItemText primary={application.form.businessType} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Contact No." />
            <ListItemText primary={application.form.contactNumber} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Email" />
            <ListItemText primary={application.form.contactEmail} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Website" />
            <ListItemText primary={application.form.website} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="No. of Employees" />
            <ListItemText primary={application.form.numberOfEmployees} />
          </ListItem>
          <ListItem>
            <ListItemText classes={{ primary: this.props.classes.listKey }} inset primary="Business Address" />
            <ListItemText primary={this.businessAddress()} />
          </ListItem>
        </List>
      </div>
    );
  }
}

const styled = withStyles(styles)(BorrowerDetails)
export default styled;



// WEBPACK FOOTER //
// ./src/components/Applications/BorrowerDetails.js